import axios from 'axios'

export default value => {
    // standalone validator ideally should not assume a field is required
    if (value === null || !value) {
      return true
    }

    return new Promise((resolve, reject) => {
      resolve(true)
    })     
  }